<script>
export default {
  name: "InteractionDetailsHyperLink",
  functional: true,
  props: {
    openDrawer: {
      type: Function
    }
    // percentFormat: {
    //   type: Boolean
    // }
  },

  render(createElement, context) {
    let element;
    element = createElement(
      "a",
      {
        attrs: {
          href: "#"
        },
        on: {
          click: () => {
            let tableCell = context.data.attrs;
            if (context.props.openDrawer) {
              context.props.openDrawer(tableCell.row, tableCell.column);
            }
          }
        }
      },
      context.data.attrs.row[context.data.attrs.column]
    );
    if (element.children[0].text != "0") {
      return element;
    }
    return (element = "");
    //return element;
  }
};
</script>
